export default __webpack_public_path__ + "3dce0a1b4ff78671c65b62862bda6f50.svg";